import { Link } from 'react-router-dom';
import { allArticles } from '@/mocks/articles';

export default function ArticlesSection() {
  const featuredArticle = allArticles[0];
  const otherArticles = allArticles.slice(1);

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-6xl mx-auto">
          <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-10 md:mb-14">
            <div>
              <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-800 text-xs font-semibold mb-3">
                / Guides /
              </span>
              <h2 className="font-heading font-bold text-2xl md:text-4xl text-foreground-900">
                Guides Hipobuy
                <br />
                Spreadsheet 2026
              </h2>
            </div>
            <p className="text-sm text-foreground-500">Tutoriels et astuces SEO — {allArticles.length} articles</p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-5 mb-10">
            <Link
              to={`/article/${featuredArticle.slug}`}
              className="lg:col-span-2 bg-background-100 rounded-xl border border-background-200/60 overflow-hidden group hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="flex flex-col md:flex-row">
                <div className="md:w-2/5 h-48 md:h-auto overflow-hidden">
                  <img
                    src={featuredArticle.imageUrl}
                    alt={featuredArticle.title}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                    loading="lazy"
                  />
                </div>
                <div className="md:w-3/5 p-5 md:p-6 flex flex-col justify-center">
                  <span className="text-xs text-accent-600 font-medium mb-2">{featuredArticle.readTime}</span>
                  <h3 className="font-heading font-semibold text-lg md:text-xl text-foreground-900 mb-2 group-hover:text-primary-700 transition-colors">
                    {featuredArticle.title}
                  </h3>
                  <p className="text-sm text-foreground-500 leading-relaxed mb-3 line-clamp-2">
                    {featuredArticle.subtitle}
                  </p>
                  <span className="text-xs text-accent-600 font-medium">
                    Lire l&apos;article →
                  </span>
                </div>
              </div>
            </Link>

            <div className="flex flex-col gap-4">
              {otherArticles.slice(0, 2).map((article) => (
                <Link
                  key={article.slug}
                  to={`/article/${article.slug}`}
                  className="bg-background-100 rounded-xl border border-background-200/60 overflow-hidden group hover:border-primary-200 transition-all duration-300 cursor-pointer"
                >
                  <div className="h-32 overflow-hidden">
                    <img
                      src={article.imageUrl}
                      alt={article.title}
                      className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                      loading="lazy"
                    />
                  </div>
                  <div className="p-4">
                    <span className="text-xs text-accent-600 font-medium mb-1 block">{article.readTime}</span>
                    <h3 className="font-heading font-semibold text-sm text-foreground-900 group-hover:text-primary-700 transition-colors line-clamp-2">
                      {article.title}
                    </h3>
                  </div>
                </Link>
              ))}
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
            {otherArticles.slice(2).map((article) => (
              <Link
                key={article.slug}
                to={`/article/${article.slug}`}
                className="bg-background-100 rounded-xl border border-background-200/60 overflow-hidden group hover:border-primary-200 transition-all duration-300 cursor-pointer"
              >
                <div className="h-40 overflow-hidden">
                  <img
                    src={article.imageUrl}
                    alt={article.title}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                    loading="lazy"
                  />
                </div>
                <div className="p-4">
                  <span className="text-xs text-accent-600 font-medium mb-1 block">{article.readTime}</span>
                  <h3 className="font-heading font-semibold text-sm text-foreground-900 group-hover:text-primary-700 transition-colors line-clamp-2">
                    {article.title}
                  </h3>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}